import { tv } from 'tailwind-variants';

export const button = tv({
  base: 'inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-lg font-circular text-base font-medium leading-5 transition duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-wx-brand-600',
  slots: {
    startIcon: 'flex size-4 shrink-0 items-center justify-center',
    endIcon: 'flex size-4 shrink-0 items-center justify-center',
  },
  compoundSlots: [
    {
      slots: ['startIcon', 'endIcon'],
      size: 'small',
      class: 'size-4',
    },
    {
      slots: ['endIcon'],
      loading: true,
      class: 'hidden',
    },
  ],
  variants: {
    variant: {
      contained:
        'bg-gradient-primary text-white transition-none hover:bg-wx-brand-600 hover:bg-none focus-visible:outline-offset-2',
      outlined:
        'bg-white ring-1 ring-wx-neutral-300 hover:bg-wx-brand-100 hover:ring-wx-brand-600',
      text: 'border-none bg-inherit hover:bg-wx-brand-50',
    },
    theme: {
      light: '',
      dark: '',
    },
    size: {
      small: 'px-3 py-1.5',
      medium: 'px-4 py-2.5',
      large: 'p-4',
    },
    color: {
      primary: 'text-wx-primary',
      secondary: 'text-wx-secondary',
      error: 'text-wx-danger-dark',
      success: 'text-wx-success-dark',
      warning: 'text-wx-warning-dark',
      white: 'text-white',
      inherit: 'text-inherit',
    },
    loading: { true: 'pointer-events-none opacity-60 focus-visible:outline-0' },
    disabled: {
      true: 'pointer-events-none border-none bg-wx-neutral-50 text-wx-neutral-300 ring-0',
    },
    fullWidth: { true: 'w-full' },
    grouped: { vertical: '' },
  },
  compoundVariants: [
    {
      variant: ['contained'],
      loading: true,
      class: 'bg-wx-brand-600 focus-visible:outline-0',
    },
    {
      variant: ['contained'],
      color: ['primary'],
      disabled: false,
      class:
        'bg-gradient-primary text-white transition-none hover:bg-wx-brand-600 hover:bg-none',
    },
    {
      variant: ['contained'],
      color: ['secondary'],
      disabled: false,
      class:
        'bg-wx-secondary text-wx-contrast-secondary hover:bg-wx-secondary hover:brightness-75',
    },
    {
      variant: ['contained'],
      color: ['error'],
      disabled: false,
      class: 'bg-wx-danger-dark text-white hover:bg-wx-rose-800',
    },
    {
      variant: ['contained'],
      color: ['success'],
      disabled: false,
      class: 'bg-wx-success-dark text-white hover:bg-wx-green-800',
    },
    {
      variant: ['contained'],
      color: ['warning'],
      class: 'bg-wx-warning-dark text-white hover:bg-wx-amber-800',
    },
    {
      theme: 'dark',
      disabled: true,
      class: 'bg-wx-neutral-900 text-wx-neutral-600',
    },
    {
      variant: ['outlined'],
      grouped: ['vertical'],
      class:
        'rounded-none first:rounded-t-lg last:rounded-b-lg focus-visible:z-50',
    },
  ],
  defaultVariants: {
    size: 'medium',
    variant: 'text',
    theme: 'light',
  },
});
